import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../../components/Cards/Card";
import KpiCard from "../../../components/KpiCard/KpiCard";

const SellThruNiveaCard = ({ app }) => {
  return (
    <Grid container className="container-cards-kpi">
      <Card
        app={app}
        className={"card-kpi-item"}
        key="FATURAMENTO_SELL_THRU_NIVEA"
        header={{ hardTitle: "Sell Thru NIVEA" }}
      >
        <KpiCard
          styles={{ boxShadow: "none" }}
          app={app}
          valueId={"EnPmL"}
          goalValueId={"fRfJDmG"}
          percentageId={"JAExHa"}
          hasProgressBar={true}
          fullView
        />
      </Card>
    </Grid>
  );
};

SellThruNiveaCard.propTypes = {
  app: PropTypes.object.isRequired,
};

export default SellThruNiveaCard;
